/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Storage_Individual_ConsumptionInputs */



/**
* | output |
* | --- |
* | "Individual space consumption" |
*
* @param {Dashboard_Storage_Individual_ConsumptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_storage_individual_consumption = /** @type {((inputs?: Dashboard_Storage_Individual_ConsumptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Storage_Individual_ConsumptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Individueller Speicherverbrauch")
	return /** @type {LocalizedString} */ ("Individual space consumption")
});